import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideNavigationMenuComponent } from './components/side-navigation-menu/side-navigation-menu.component';
import { HeaderComponent } from './components/header/header.component';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './services/auth.service';
import { CommonModule } from '@angular/common';
import { IconServiceService } from './services/icon-service.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UtilitiesService } from './services/utilities.service';
import { GlobalVariables } from './constants/global-constants';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SideNavigationMenuComponent,
    HeaderComponent,
    MatProgressSpinnerModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Fraud Deflect';
  http = inject(HttpClient);
  authenticated = false;
  fullpage: false;
  fullpageLoading = false;
  constructor(private titleService: Title, private authService: AuthService,
    private iconService: IconServiceService,
    private utilities: UtilitiesService,
    private languageService: LanguageService
  ) {
    this.titleService.setTitle(this.title);
    this.iconService.registerIcons();
    this.checkLanguage();
    this.utilities.setTheme('');
    
    this.utilities.fullPageLoadingEvent.subscribe((loading) => {
      this.fullpageLoading = loading;
    });
  }

  checkLanguage() {
    //check if stored locale is the same as URL locale. If not switch to stored locale
    var countryList = GlobalVariables.countries;
    var urlCountry = countryList.filter(x => window.location.href.indexOf('/' + x.languageCd + '/') > 0)[0];
    var localStorageLocale = this.languageService.locale;
    if (urlCountry && localStorageLocale && localStorageLocale != urlCountry.languageCd) {
      this.languageService.changeLanguage(localStorageLocale);
    }
    else if (urlCountry && urlCountry.languageCd) {
      this.languageService.locale = urlCountry.languageCd;
    }
  }

  isAuthenticated() {
    return this.authService.loggedIn();
  }
}
